module.exports = __webpack_public_path__ + "static/media/3_11.8a10db57.png";